﻿import { createBrowserRouter } from 'react-router-dom';

import { RootLayout } from '../layouts/RootLayout';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

import { HomePage } from '../pages/HomePage';
import { ShopPage } from '../pages/ShopPage';
import { ProductDetail } from '../pages/ProductDetail';
import { CoursesPage } from '../pages/CoursesPage';
import { CourseDetail } from '../pages/CourseDetail';
import { LiveClassListPage } from '../pages/live-classes/LiveClassListPage';
import { LiveClassDetailPage } from '../pages/live-classes/LiveClassDetailPage';
import { LiveClassRoom } from '../pages/live-classes/LiveClassRoom';
import { MyLiveClasses } from '../pages/dashboard/MyLiveClasses';
import { CartPage } from '../pages/CartPage';
import { CheckoutPage } from '../pages/CheckoutPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { RepairsPage } from '../pages/RepairsPage';
import { WishlistPage } from '../pages/WhishlistPage';

import { DashboardHome } from '../pages/dashboard/DashboardHome';
import { ProfilePage } from '../pages/dashboard/ProfilePage';
import { RepairList } from '../pages/dashboard/RepairList';
import { RepairDetail } from '../pages/dashboard/RepairDetail';
import { RepairBookingForm } from '../components/repairs/RepairBookinForm';
import { CoursesList } from '../pages/dashboard/CoursesList';
import { NotificationsPage } from '../pages/dashboard/NotificationsPage';
import { SettingsPage } from '../pages/dashboard/SettingsPage';
import { CheckoutPaymentPage } from '../pages/CheckoutPaymentPage';
import { OrdersPage } from '../pages/OrderPage';
import { OrderDetailPage } from '../pages/OrderDetailPage';
import { OrderConfirmationPage } from '../pages/OrderConfirmationPage';
import { LessonPlayer } from '../pages/learning/LessonPlayer';
import { QuizPage } from '../pages/learning/QuizPage';
import { CertificatesPage } from '../pages/dashboard/Certificates';
import { CertificateVerifyPage } from '../pages/certificates/CertificateVerifyPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'shop', element: <ShopPage /> },
      { path: 'shop/:slug', element: <ProductDetail /> },
      { path: 'courses', element: <CoursesPage /> },
      { path: 'courses/:slug', element: <CourseDetail /> },
      { path: 'live-classes', element: <LiveClassListPage /> },
      { path: 'live-classes/:id', element: <LiveClassDetailPage /> },
      {
        path: 'live-classes/:classId/sessions/:sessionId/room',
        element: (
          <ProtectedRoute>
            <LiveClassRoom />
          </ProtectedRoute>
        ),
      },
      { path: 'cart', element: <CartPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
      { path: 'repairs', element: <RepairsPage /> },
      { path: 'repairs/book', element: <RepairBookingForm /> },
      { path: 'wishlist', element: <WishlistPage /> },
      { path: 'checkout/pay/:id', element: <CheckoutPaymentPage /> },
      { path: 'order-confirmation/:id?', element: <OrderConfirmationPage /> },
      { path: 'certificates/:serial/verify', element: <CertificateVerifyPage /> },
    ],
  },
  {
    path: 'learn/:slug/lessons/:lessonId',
    element: (
      <ProtectedRoute>
        <LessonPlayer />
      </ProtectedRoute>
    ),
  },
  {
    path: 'learn/:slug/quiz',
    element: (
      <ProtectedRoute>
        <QuizPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardHome /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'repairs', element: <RepairList /> },
      { path: 'repairs/new', element: <RepairBookingForm /> },
      { path: 'repairs/:id', element: <RepairDetail /> },
      { path: 'courses', element: <CoursesList /> },
      { path: 'live-classes', element: <MyLiveClasses /> },
      { path: 'certificates', element: <CertificatesPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  {
    path: 'orders',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <OrdersPage /> },
      { path: ':id', element: <OrderDetailPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
